<script>
    import MfaAuth from "../../Pages/Auth/MfaAuth.svelte";
</script>

<div class="flex flex-col flex-1 w-full align-left">
    <MfaAuth />
</div>
